const PHONE = '561-445-3948';

const services = [
  'Pressure Cleaning',
  'Roof Cleaning',
  'Driveway Cleaning',
  'Screen Patios',
  'Gutter Cleaning',
];

const serviceAreas = [
  'Boca Raton',
  'Delray Beach',
  'Coral Springs',
  'Boynton Beach',
  'West Palm Beach',
  'Pompano Beach',
  'Lake Worth',
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-teal-600">
                <i className="ri-water-flash-fill text-white text-xl"></i>
              </div>
              <div>
                <p className="font-bold text-sm leading-tight text-white">Total Residential</p>
                <p className="text-xs leading-tight font-medium text-teal-400">Solution Inc</p>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              Professional pressure washing and roof cleaning services across South Florida.
              Licensed, insured, and trusted by hundreds of homeowners since 2008.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://facebook.com"
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-slate-800 hover:bg-teal-700 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-white text-base"></i>
              </a>
              <a
                href="https://instagram.com"
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-slate-800 hover:bg-teal-700 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-white text-base"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              <a href="#services">Our Services</a>
            </h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    className="text-slate-400 text-sm hover:text-teal-400 transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-teal-600 text-base"></i>
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              <a href="#contact">Service Areas</a>
            </h4>
            <ul className="space-y-2.5">
              {serviceAreas.map((area) => (
                <li key={area}>
                  <span className="text-slate-400 text-sm flex items-center gap-2">
                    <i className="ri-map-pin-line text-teal-600 text-base"></i>
                    {area}, FL
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              Contact Us
            </h4>
            <div className="space-y-4">
              <a
                href={`tel:${PHONE}`}
                className="flex items-center gap-3 cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-teal-700 group-hover:bg-teal-600 transition-colors">
                  <i className="ri-phone-fill text-white text-base"></i>
                </div>
                <div>
                  <p className="text-xs text-slate-500 mb-0.5">Call or text anytime</p>
                  <p className="text-orange-400 font-bold text-lg">{PHONE}</p>
                </div>
              </a>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800">
                  <i className="ri-map-pin-2-line text-teal-400 text-base"></i>
                </div>
                <div>
                  <p className="text-xs text-slate-500 mb-0.5">Serving</p>
                  <p className="text-slate-300 text-sm font-medium">South Florida</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800">
                  <i className="ri-time-line text-teal-400 text-base"></i>
                </div>
                <div>
                  <p className="text-xs text-slate-500 mb-0.5">Hours</p>
                  <p className="text-slate-300 text-sm">Mon–Sat: 7AM – 6PM</p>
                </div>
              </div>
              <a
                href="#contact"
                className="block bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-4 rounded-lg text-center text-sm transition-colors cursor-pointer whitespace-nowrap mt-2"
              >
                Get Free Estimate
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs text-center md:text-left">
            © 2025 Total Residential Solution Inc. All rights reserved. | Pressure Cleaning South Florida
          </p>
          <p className="text-slate-500 text-xs text-center flex items-center gap-2">
            <i className="ri-shield-check-line text-teal-600 text-sm"></i>
            Licensed &amp; Insured in Florida
          </p>
        </div>
      </div>
    </footer>
  );
}
